import React from "react";
import { useTranslation } from "react-i18next";
import { Patient } from "model/patient.model";
import { PatientInfo } from "components";
import { Form, ListGroup } from "@cc/react-components";

export interface Props {
  searchResults: Patient[];
  onSearchPatient: any;
  onSelectPatient(patient: Patient): void;
  searchKey: string;
}

const PatientSearch = ({
  searchResults,
  onSearchPatient,
  onSelectPatient,
  searchKey,
}: Props) => {
  const [t] = useTranslation();

  return (
    <div className="h-100 w-100 d-flex flex-column">
      {renderTextInput(searchKey, onSearchPatient, t)}
      <div className="flex-grow-1">
        {renderResults(searchResults, onSelectPatient, t)}
      </div>
    </div>
  );
};

const renderTextInput = (searchKey: string, onSearchPatient: any, t: any) => (
  <Form.Input
    type="text"
    className="mt-3 mb-3"
    placeholder={t("patientSearch.search")}
    value={searchKey}
    onChange={(event: any) => {
      onSearchPatient(event.target.value);
    }}
  />
);

const renderResults = (
  searchResults: Patient[],
  onSelectPatient: any,
  t: any
) => {
  const items = searchResults.map((patient: Patient) => (
    <ListGroup.Item key={patient.id} onClick={() => onSelectPatient(patient)}>
      <PatientInfo avatar={true} patient={patient} />
    </ListGroup.Item>
  ));
  if (searchResults.length >= 5) {
    items.push(
      <ListGroup.Item key={0}>
        <p className="text-bold text-center">
          {t("patientSearch.moreResults")}
        </p>
      </ListGroup.Item>
    );
  }
  return <ListGroup>{items}</ListGroup>;
};

export default PatientSearch;
